// src/api/axios.ts
import { API_URLS, apiUrl } from '@/config/api.config';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { authService } from '@/services/authService';

// Use an empty baseURL in development so the browser requests go to the Vite dev server
// and the proxy defined in `vite.config.ts` can forward `/api` to the backend.
// Electron renderer sometimes doesn't expose `import.meta.env.DEV`, so also detect
// dev by checking the location hostname.

const instance: AxiosInstance = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});

// Interceptor para agregar el token de autenticación - ✅ UNIFICADO
instance.interceptors.request.use(
  config => {
    const token = authService.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// ⬇️ Este es el *mutator* que Orval necesita: una FUNCIÓN exportada con el nombre que pusiste en orval.config.ts
export const axiosInstance = async <TData = unknown>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<TData> => {
  const response = await instance.request<TData>({ ...config, ...options });
  return response.data;
};
